<template>
  <form novalidate class="md-layout" @submit.prevent="validateUser">
    <div class="md-layout-item md-elevation-0">

      <md-card class="md-elevation-0 m-5">
        <md-card-header class="md-layout md-alignment-center-left justify header-bg">
          Cuestionario de Perfil de Riesgo del Inversionista
        </md-card-header>
        <md-card-content class="md-layout">
          <p align="justify">
            El presente cuestionario tiene por objeto determinar el perfil de riesgo de un inversionista a partir de la evaluación de un grupo de factores y criterios, tales como: su situación personal y financiera actual, sus objetivos de inversión y tolerancia al riesgo, así como sus conocimientos y experiencia en inversión. De esa forma se define algunos de los tres perfiles de riesgo posibles: conservador, moderado y agresivo. Ello representa el primer paso para que usted y su asesor puedan preparar juntos su plan de inversión.
          </p>
          <p align="justify">
            Las respuestas al presente cuestionario son estrictamente confidenciales. Cabe señalar que el potencial inversionista es responsable por la veracidad de la información para así asegurar la obtención de un resultado confiable que contribuya a una mejor toma de decisiones de inversión.
          </p>
            <p align="justify">
              Ante cualquier duda, comuníquese con su promotor.
            </p>           
        </md-card-content> 
      </md-card>    

      <md-card class="md-elevation-0 m-5" >
        <md-card-header class="md-layout md-alignment-center-left justify">
          <b>
          Información General
          </b>
        </md-card-header>
 
      </md-card>            

      <md-card class="md-elevation-0 m-5" :class="getValidationClass('rango')">
        <md-card-header class="md-layout md-alignment-center-left justify">
          1. Rango de ingresos actuales *
        </md-card-header>
        <md-card-content class="md-layout">
            <p align="justify">
                En caso requiera mayor información sobre este punto, por favor, comuníquese con su promotor.
            </p>

            <div v-for="(value, i) in itema" :key="i" class="md-layout-item md-layout md-size-100 md-alignment-center-left">
              <div class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-10 md-small-size-5 md-xsmall-size-10">
                <md-checkbox v-model="form.rango" :value="value" />
              </div>
              <div class="md-layout-item md-xlarge-size-95 md-large-size-95 md-medium-size-90 md-small-size-95 md-xsmall-size-90">
                <p class="justify">
                  {{value}}
                </p>
              </div>
            </div>
                                                                                    
            <div class="radioform" :class="getValidationClass('rango')">
              <span class="md-error" v-if="!$v.form.rango.required">Esta respuesta es obligatoria.</span>
            </div>              

        </md-card-content> 
      </md-card>    

        <md-card class="md-elevation-0 m-5" :class="getValidationClass2('fuente')">
          <md-card-header  class="md-layout md-alignment-center-left justify">
           2. Fuente de ingresos *
          </md-card-header>
          <md-card-content>           
              <div class="md-layout-item md-layout">
                <div class="md-layout-item md-layout-item md-xlarge-size-25 md-large-size-30 md-medium-size-30 md-small-size-35 md-xsmall-size-100 md-gutter md-alignment-bottom-left">

                  <md-checkbox class="checkbox-flex" v-model="form.fuente" value="Empleo / Sueldo">Empleo / Sueldo</md-checkbox>
                  <md-checkbox class="checkbox-flex" v-model="form.fuente" value="Inversiones">Inversiones</md-checkbox>
                  <md-checkbox class="checkbox-flex" v-model="form.fuente" value="Herencia">Herencia</md-checkbox>
                  <md-checkbox class="checkbox-flex" v-model="form.fuente" value="Pensión">Pensión</md-checkbox>
                  <md-checkbox class="checkbox-flex" v-model="form.fuente" value="Otros" @change="ChangeOption">Otros</md-checkbox>
                </div>
                <div class="md-layout md-layout-item md-gutter md-alignment-bottom-left">
                    <div class="md-layout-item">

                      <md-field class="md-field-aux" :class="getValidationClass('fuentedes')">
                        <md-input type="text" name="otros" placeholder="Su respuesta" v-model="form.fuentedes" autocomplete="off" :disabled="otros" />
                        <span class="md-error" v-if="!$v.form.fuente.required">Esta respuesta es obligatoria.</span>
                        <span class="md-error" v-if="!$v.form.fuente.alpha1">Esta respuesta es obligatoria.</span>
                      </md-field>   

                    </div>
  
                </div>
              </div>  

              <div class="radioform" :class="getValidationClass('fuente')">
                <span class="md-error" v-if="!$v.form.fuente.required">Esta respuesta es obligatoria.</span>
              </div>                                    

          </md-card-content>
        </md-card>   

      <md-card class="md-elevation-0 m-5" :class="getValidationClass('experiencia')">
        <md-card-header class="md-layout md-alignment-center-left justify">
          3. Experiencia de inversión *
        </md-card-header>
        <md-card-content class="md-layout">
            <p align="justify">
                En caso requiera mayor información sobre este punto, por favor, comuníquese con su promotor.
            </p>

            <div v-for="(value, i) in itemb" :key="i" class="md-layout-item md-layout md-size-100 md-alignment-center-left">
              <div class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-10 md-small-size-5 md-xsmall-size-10">
                <md-checkbox v-model="form.experiencia" :value="value" />
              </div>
              <div class="md-layout-item md-xlarge-size-95 md-large-size-95 md-medium-size-90 md-small-size-95 md-xsmall-size-90">
                <p class="justify">
                  {{value}}
                </p>
              </div>
            </div>            

            <div class="radioform" :class="getValidationClass('experiencia')">
              <span class="md-error" v-if="!$v.form.experiencia.required">Esta respuesta es obligatoria.</span>
            </div>              

        </md-card-content> 
      </md-card> 

      <md-card class="md-elevation-0 m-5" :class="getValidationClass('objetivos')">
        <md-card-header class="md-layout md-alignment-center-left justify">
          4. Objetivos generales de inversión *
        </md-card-header>
        <md-card-content class="md-layout">
            <p align="justify">
                En caso requiera mayor información sobre este punto, por favor, comuníquese con su promotor.
            </p>

            <div v-for="(value, i) in itemc" :key="i" class="md-layout-item md-layout md-size-100 md-alignment-top-left">
              <div class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-10 md-small-size-5 md-xsmall-size-10">
                <md-checkbox v-model="form.objetivos" :value="value" />
              </div>
              <div class="md-layout-item md-xlarge-size-95 md-large-size-95 md-medium-size-90 md-small-size-95 md-xsmall-size-90">
                <p class="justify">
                  {{value}}
                </p>
              </div>
            </div>              

            <div class="radioform" :class="getValidationClass('objetivos')">
              <span class="md-error" v-if="!$v.form.objetivos.required">Esta respuesta es obligatoria.</span>
            </div>              

        </md-card-content> 
      </md-card>      

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('horizonte')">
            <md-card-header class="md-layout md-alignment-center-left justify">
            5. Por favor marque cuál es su horizonte de inversión para la presente cuenta (solo una): *
            </md-card-header>
            <md-card-content>

                <div v-for="(value, i) in itemd" :key="i" class="md-layout-item md-layout md-size-100 md-alignment-top-left">
                  <div class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-10 md-small-size-5 md-xsmall-size-10">
                    <md-checkbox v-model="form.horizonte"  :value="value" />
                  </div>
                  <div class="md-layout-item md-xlarge-size-95 md-large-size-95 md-medium-size-90 md-small-size-95 md-xsmall-size-90">
                    <p class="justify">
                      {{value}}
                    </p>
                  </div>
                </div>                       

                <div class="radioform" :class="getValidationClass('horizonte')">
                <span class="md-error" v-if="!$v.form.horizonte.required">Esta respuesta es obligatoria.</span>
                </div>

            </md-card-content> 
        </md-card>     


      <md-card class="md-elevation-0 m-5" >
        <md-card-header class="md-layout md-alignment-center-left justify">
          <b>Perfil de Riesgo</b>
        </md-card-header>
      </md-card>  

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('fraserespectoriesgo')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            ¿Qué frase lo identifica mejor con respecto al riesgo? *
          </md-card-header>
          <md-card-content>

                <div v-for="(value, i) in iteme" :key="i" class="md-layout-item md-layout md-size-100 md-alignment-top-left">
                  <div class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-10 md-small-size-5 md-xsmall-size-10">
                    <md-checkbox v-model="form.fraserespectoriesgo"  :value="value" />
                  </div>
                  <div class="md-layout-item md-xlarge-size-95 md-large-size-95 md-medium-size-90 md-small-size-95 md-xsmall-size-90">
                    <p class="justify">
                      {{value}}
                    </p>
                  </div>
                </div>                    

              <div class="radioform" :class="getValidationClass('fraserespectoriesgo')">
                <span class="md-error" v-if="!$v.form.fraserespectoriesgo.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>   


        <md-card class="md-elevation-0 m-5" :class="getValidationClass('identificaactitudahorro')">
          <md-card-header class="md-layout md-alignment-center-left justify justify">
            ¿Qué frase lo identifica mejor con respecto a su actitud hacia el ahorro? *
          </md-card-header>
          <md-card-content>
                          
              <div v-for="(value, i) in itemf" :key="i" class="md-layout-item md-layout md-size-100 md-alignment-top-left">
                <div class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-10 md-small-size-5 md-xsmall-size-10">
                  <md-checkbox v-model="form.identificaactitudahorro"  :value="value" />
                </div>
                <div class="md-layout-item md-xlarge-size-95 md-large-size-95 md-medium-size-90 md-small-size-95 md-xsmall-size-90">
                  <p class="justify">
                    {{value}}
                  </p>
                </div>
              </div>                 

              <div class="radioform" :class="getValidationClass('identificaactitudahorro')">
                <span class="md-error" v-if="!$v.form.identificaactitudahorro.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>   

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('perderinversion')">
          <md-card-header class="md-layout md-alignment-center-left justify justify">
            ¿En qué medida toleraría la posibilidad de perder parte de su inversión? *
          </md-card-header>
          <md-card-content> 

              <div v-for="(value, i) in itemg" :key="i" class="md-layout-item md-layout md-size-100 md-alignment-top-left">
                <div class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-10 md-small-size-5 md-xsmall-size-10">
                  <md-checkbox v-model="form.perderinversion"  :value="value" />
                </div>
                <div class="md-layout-item md-xlarge-size-95 md-large-size-95 md-medium-size-90 md-small-size-95 md-xsmall-size-90">
                  <p class="justify">
                    {{value}}
                  </p>
                </div>
              </div>                    

              <div class="radioform" :class="getValidationClass('perderinversion')">
                <span class="md-error" v-if="!$v.form.perderinversion.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>   

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('rangoedad')">
          <md-card-header class="md-layout md-alignment-center-left justify justify">
            ¿En qué rango de edad se encuentra? *
          </md-card-header>
          <md-card-content>     

              <div v-for="(value, i) in itemh" :key="i" class="md-layout-item md-layout md-size-100 md-alignment-top-left">
                <div class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-10 md-small-size-5 md-xsmall-size-10">
                  <md-checkbox v-model="form.rangoedad"  :value="value" />
                </div>
                <div class="md-layout-item md-xlarge-size-95 md-large-size-95 md-medium-size-90 md-small-size-95 md-xsmall-size-90">
                  <p class="justify">
                    {{value}}
                  </p>
                </div>
              </div>   
              <div class="radioform" :class="getValidationClass('rangoedad')">
                <span class="md-error" v-if="!$v.form.rangoedad.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>   

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('utilizarinversion')">
          <md-card-header class="md-layout md-alignment-center-left justify justify">
            ¿En cuánto tiempo espera comenzar a utilizar su inversión? *
          </md-card-header>
          <md-card-content>
                      
              <div v-for="(value, i) in itemi" :key="i" class="md-layout-item md-layout md-size-100 md-alignment-top-left">
                <div class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-10 md-small-size-5 md-xsmall-size-10">
                  <md-checkbox v-model="form.utilizarinversion" :value="value" />
                </div>
                <div class="md-layout-item md-xlarge-size-95 md-large-size-95 md-medium-size-90 md-small-size-95 md-xsmall-size-90">
                  <p class="justify">
                    {{value}}
                  </p>
                </div>
              </div>                     

              <div class="radioform" :class="getValidationClass('utilizarinversion')">
                <span class="md-error" v-if="!$v.form.utilizarinversion.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>   

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('capacidadahorroestimada')">
          <md-card-header class="md-layout md-alignment-center-left justify justify">
            De tu ingreso mensual, tu capacidad de ahorro estimada es: *
          </md-card-header>
          <md-card-content>
                      
              <div v-for="(value, i) in itemj" :key="i" class="md-layout-item md-layout md-size-100 md-alignment-top-left">
                <div class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-10 md-small-size-5 md-xsmall-size-10">
                  <md-checkbox v-model="form.capacidadahorroestimada" :value="value" />
                </div>
                <div class="md-layout-item md-xlarge-size-95 md-large-size-95 md-medium-size-90 md-small-size-95 md-xsmall-size-90">
                  <p class="justify">
                    {{value}}
                  </p>
                </div>
              </div>                      

              <div class="radioform" :class="getValidationClass('capacidadahorroestimada')">
                <span class="md-error" v-if="!$v.form.capacidadahorroestimada.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>   

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('disminucionportafolioasumir')">
          <md-card-header class="md-layout md-alignment-center-left justify justify">
            El valor de las inversiones varía a lo largo del tiempo en función a una serie de factores. En un periodo de un año, ¿cuál sería la máxima disminución del valor del portafolio que estarías dispuesto a asumir? *
          </md-card-header>
          <md-card-content>

              <div v-for="(value, i) in itemk" :key="i" class="md-layout-item md-layout md-size-100 md-alignment-top-left">
                <div class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-10 md-small-size-5 md-xsmall-size-10">
                  <md-checkbox v-model="form.disminucionportafolioasumir" :value="value" />
                </div>
                <div class="md-layout-item md-xlarge-size-95 md-large-size-95 md-medium-size-90 md-small-size-95 md-xsmall-size-90">
                  <p class="justify">
                    {{value}}
                  </p>
                </div>
              </div>                       

              <div class="radioform" :class="getValidationClass('disminucionportafolioasumir')">
                <span class="md-error" v-if="!$v.form.disminucionportafolioasumir.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>   

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('inversionpasada')">
          <md-card-header class="md-layout md-alignment-center-left justify justify">
            De los siguientes instrumentos financieros, ¿en cuáles inviertes o has invertido en el pasado? *
          </md-card-header>
          <md-card-content>

              <div v-for="(value, i) in iteml" :key="i" class="md-layout-item md-layout md-size-100 md-alignment-top-left">
                <div class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-10 md-small-size-5 md-xsmall-size-10">
                  <md-checkbox v-model="form.inversionpasada" :value="value" />
                </div>
                <div class="md-layout-item md-xlarge-size-95 md-large-size-95 md-medium-size-90 md-small-size-95 md-xsmall-size-90">
                  <p class="justify">
                    {{value}}
                  </p>
                </div>
              </div>                      

              <div class="radioform" :class="getValidationClass('inversionpasada')">
                <span class="md-error" v-if="!$v.form.inversionpasada.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>   

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('rangorentabilidad')">
          <md-card-header class="md-layout md-alignment-center-left justify justify">
            Supón que has invertido $1.000.000, ¿en cuál de los siguientes rangos de rentabilidad te sentirías más cómodo? *
          </md-card-header>
          <md-card-content>
                       
              <div v-for="(value, i) in itemm" :key="i" class="md-layout-item md-layout md-size-100 md-alignment-top-left">
                <div class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-10 md-small-size-5 md-xsmall-size-10">
                  <md-checkbox v-model="form.rangorentabilidad" :value="value" />
                </div>
                <div class="md-layout-item md-xlarge-size-95 md-large-size-95 md-medium-size-90 md-small-size-95 md-xsmall-size-90">
                  <p class="justify">
                    {{value}}
                  </p>
                </div>
              </div>                   


              <div class="radioform" :class="getValidationClass('rangorentabilidad')">
                <span class="md-error" v-if="!$v.form.rangorentabilidad.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>                                                                                       

      <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>                  
      
    </div>
  </form>
</template>

<style>

</style>

<script>
import { validationMixin } from 'vuelidate'
import { alpha1 } from '../variables'
import {
  required,
  requiredIf
} from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  name: 'Item13',
  props: ["title", "data"],
  data: () => ({
    form:{
    },
    itema:[
        "Menos de $25,000",
        "$25,000 - $50,000",
        "$50,000 - $100,000",
        "$100,000 - $250,000",
        "$250,000 - $500,000",
        "Más de $500,000"
    ],
    itemb:[
        "Muy limitada (0-1 año)",
        "Limitada (menos de 5 años)",
        "Moderada (5-10 años)",
        "Extensa (más de 10 años)"
    ],
    itemc:[
        "Generar ingresos",
        "Acumular riqueza en el Largo Plazo",
        "Retiro / Jubilación",
        "Fondos Educativos"
    ],
    itemd:[
        "Inmediata",
        "Corto Plazo: menos de 3 años",
        "Mediano Plazo: entre 3 y 10 años",
        "Largo Plazo: más de 10 años"
    ],
    iteme:[
        "Invertiría todo mi dinero en instrumentos de alta rentabilidad, aun cuando esto signifique asumir mayores riesgos.",
        "Invertiría una parte de mi dinero en instrumentos de bajo riesgo y otra, en aquellos que, aunque son más riesgosos, tienen mayor rentabilidad.",
        "Invertiría todo mi dinero en instrumentos con poco riesgo, aunque su rentabilidad sea baja."
    ],
    itemf:[
        "Me considero un inversionista y estoy dispuesto a asumir mayor riesgo con el objeto de obtener un mejor rendimiento.",
        "Me considero más un ahorrista que un inversionista, pero estoy dispuesto a asumir cierto riesgo con el objeto de obtener un mejor rendimiento.",
        "Me considero un ahorrista."
    ],
    itemg:[
        "No me preocupa perder mi inversión porque ya tengo provisiones que cubren mis necesidades.",
        "Puedo tolerar pequeñas fluctuaciones en mis rendimientos (incluso algunos resultados negativos) porque estoy invirtiendo a largo plazo.",
        "No me puedo permitir perder cualquier parte de mi inversión, ya que no podría mantener mi nivel de vida.",
    ],
    itemh:[
        "Entre 18 y 35 años",
        "Entre 36 y 49 años",
        "Mayor de 50 años"
    ],
    itemi:[
        "En más de 5 años",
        "Entre 3 a 5 años",
        "Antes de 3 años"
    ],
    itemj:[
        "Menos del 20%",
        "Entre 20% y 40%",
        "Más del 40%"
    ],    
    itemk:[
        "No tolero pérdidas en mi patrimonio.",
        "Aceptaría pérdidas de hasta 10%.",
        "Aceptaría pérdidas de hasta 20%.",
        "Aceptaría pérdidas de hasta 30%.",
        "Aceptaría pérdidas de más de 30%"
    ],
    iteml:[
        "Nunca he invertido en instrumentos financieros.",
        "Depósitos a plazo",
        "Fondos Mutuos y/o acciones",
        "Opciones, derivados y/o Forwards."
    ],
    itemm:[
        "Perder $10,000 o ganar $100,000",
        "Perder $110,000 o ganar $300,000",
        "Perder $180,000 o ganar $400,000"
    ]    
  }),
  mounted: function(){
    this.form = this.$store.state.item.item13

  },  
  validations: {
    form: {
        rango:  {required,},
        fuente:  {required},
        fuentedes:  {
          required: requiredIf(function(form,){
            return this.findArray(form.fuente)
          }),
          alpha1,     
        },
        experiencia:  {required,},
        objetivos:  {required,},
        horizonte:  {required,},
        fraserespectoriesgo:  {required,},
        identificaactitudahorro:  {required,},
        perderinversion:  {required,},
        rangoedad:  {required,},
        utilizarinversion:  {required,},
        capacidadahorroestimada:  {required,},
        disminucionportafolioasumir:  {required,},
        inversionpasada:  {required,},
        rangorentabilidad: {required,},
    },
  },
  methods: {
    ChangeOption(item){
      var that = this;
      item.find(x => {
        if(x != "Otros"){
          that.form.fuentedes = null
        }
      });

    },      
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.item.item13
    },    
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        var index = "0"
        if(this.data.name == "Participe"){
          index = "14"
        }else{
          index = "16"
        }
        this.$emit('setSaveForm', {id:"13", form: this.form, index: index});
      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    getValidationClass2 (fieldName) {
      const field = this.$v.form[fieldName]
      const field1 = this.$v.form[fieldName+"des"]

      if (field) {

        var x = field.$invalid && field.$dirty;
        var y = field1.$invalid && field1.$dirty;

        return {
          'md-invalid': x || y
        }
      }
    },

    findArray(arr){

      try {
        return (arr.find(x => x == "Otros") == "Otros")
      } catch (error) {
        return true;
      }

    }

  },
  computed: { 
    otros: function () {
      return !this.findArray(this.form.fuente)
    },      
    isRequired:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    },
    isVisible:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    }

  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }            
}
</script>
